<div class="less-margin-left">
  <ngx-skeleton-loader
    *ngIf="job.jobId === ''"
    count="1"
    [theme]="{ 'border-radius': '4px', height: '155px' }"
  ></ngx-skeleton-loader>
  <div *ngIf="job.jobId !== ''">
    <div class="grid-definition">
      <div class="text-center">
        <i class="fas fa-folder"></i>
      </div>
      <span>{{ job.jobId }}</span>
    </div>
    <div class="grid-definition">
      <div class="text-center">
        <i class="far fa-user" *ngIf="job.driverType === 'Solo'"></i>
        <i class="fas fa-user-friends" *ngIf="job.driverType === 'Team'"></i>
        <i class="fas fa-chalkboard-teacher" *ngIf="job.driverType === 'Trainer'"></i>
      </div>
      <span>{{ job.driverType }}</span>
    </div>
    <div *ngIf="job.experience !== ''" class="grid-definition">
      <div class="text-center">
        <i class="fas fa-briefcase"></i>
      </div>
      <span>{{ job.experience }}</span>
    </div>
    <div *ngIf="job.homeTime !== ''" class="grid-definition">
      <div class="text-center">
        <i class="fas fa-home-lg"></i>
      </div>
      <span>{{ job.homeTime }}</span>
    </div>
    <div *ngIf="!job.hideWage" class="grid-definition-wage">
      <div class="text-center">
        <i class="far fa-money-check-edit-alt"></i>
      </div>
      <span>Average: {{ job.wageAverageWeekly }}/wk</span
      ><span class="per-year">({{ job.wageAverageAnnualized }}/yr)</span>
    </div>
    <div *ngIf="!job.hideWageYear" class="grid-definition-wage">
      <div class="text-center">
        <i class="fas fa-sack-dollar"></i>
      </div>
      <span>Top 10%: {{ job.wageTopWeekly }}/wk</span
      ><span class="per-year">({{ job.wageTopAnnualized }}/yr)</span>
    </div>
    <div *ngIf="job.domiciles" class="grid-definition-domicile" (click)="expanded = !expanded">
      <div class="text-center">
        <i class="fas fa-map-marker-alt"></i>
      </div>
      <span>{{ job.domiciles.length }} Hiring Areas</span>
      <i class="fas arrow" [class.fa-caret-up]="expanded" [class.fa-caret-down]="!expanded"></i>
    </div>
    <div *ngIf="job.domiciles && expanded">
      <div *ngFor="let domicile of job.domiciles" class="grid-definition-domiciles">
        <div class="text-center"></div>
        <app-shared-display-city-state
          [city]="domicile.city"
          [state]="domicile.state"
        ></app-shared-display-city-state>
      </div>
    </div>
  </div>
</div>
